import { useContext } from "react";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import Icon, { ClickableIcon } from "../../components/Icon";
import Modal from "../../components/Modal";
import Status from "../../types/enum/Status";
import { UserContext } from "../../context/UserContext";

interface DocDownloadsModalProps {
  isOpen: boolean;
  fetchOfficialTranscript: () => void;
  fetchUnofficialTranscript: () => void;
  fetchVerificationLetter: () => void;
  fetchCertificateOfStatus: () => void;
  printOfficialTranscript: () => void;
  setOpen: (isOpen: boolean) => void;
}
export const DocDownloadsModal = (props: DocDownloadsModalProps) => {
  const {
    isOpen,
    setOpen,
    fetchOfficialTranscript,
    fetchUnofficialTranscript,
    fetchVerificationLetter,
    fetchCertificateOfStatus,
    printOfficialTranscript,
  } = props;

  const { user } = useContext(UserContext);

  return (
    <Modal
      isOpen={!!isOpen}
      setOpen={setOpen}
      onClose={() => setOpen(false)}
      customStyle={{
        content: {
          maxWidth: "700px",
          margin: "57px auto 0px",
          maxHeight: "80vh",
        },
      }}
    >
      <FlexBox>
        <FlexGrow>
          <h3 style={{ marginBottom: 20 }}>Available Documents</h3>
        </FlexGrow>
        <ClickableIcon name="x-s" onClick={() => setOpen(false)} />
      </FlexBox>
      {user?.role === "admin" && <FlexBox
        style={{
          justifyContent: "space-between",
          paddingTop: 20,
          paddingBottom: 20,
          borderBottom: "1px solid #ddd9d9",
        }}
      >
        <span>
          <div style={{ fontSize: 18, fontWeight: 500, color: "#820000" }}>
            <Icon name="file-s" mr={0.5} />
            Official Transcript{" "}
          </div>
          <div style={{ color: "#2b2b2bff" }}>
            For official academic purposes
          </div>
        </span>
        <div>
          <Button
            style={{ minWidth: 150 }}
            status={Status.blue}
            backgroundColor="#0762ffff"
            onClick={() => {
              // setOpen(false);
              printOfficialTranscript();
            }}
          // status={Status.light}
          >
            <Icon name="printer" mr={0.5} />
            Print
          </Button>
          <Button
            style={{
              minWidth: 150,
              color: "#006900",
              borderColor: "#006900",
              marginLeft: 10,
            }}
            isOutline
            onClick={() => {
              // setOpen(false);
              fetchOfficialTranscript();
            }}
          // status={Status.light}
          >
            <Icon name="download" mr={0.5} />
            Download PDF
          </Button>
        </div>
      </FlexBox>}
      <FlexBox
        style={{
          justifyContent: "space-between",
          paddingTop: 20,
          paddingBottom: 20,
          borderBottom: "1px solid #ddd9d9",
        }}
      >
        <span>
          <div style={{ fontSize: 18, fontWeight: 500, color: "#820000" }}>
            <Icon name="file-s" mr={0.5} />
            Unofficial Transcript{" "}
          </div>
          <div style={{ color: "#2b2b2bff" }}>For personal reference</div>
        </span>
        <Button
          style={{ minWidth: 150, color: "#006900", borderColor: "#006900" }}
          isOutline
          onClick={() => {
            fetchUnofficialTranscript();
            // setOpen(false);
          }}
        // status={Status.light}
        >
          <Icon name="download" mr={0.5} />
          Download PDF
        </Button>
      </FlexBox>
      {user?.role === "admin" && <><FlexBox
        style={{
          justifyContent: "space-between",
          paddingTop: 20,
          paddingBottom: 20,
          borderBottom: "1px solid #ddd9d9",
        }}
      >
        <span>
          <div style={{ fontSize: 18, fontWeight: 500, color: "#820000" }}>
            <Icon name="file-s" mr={0.5} />
            Enrollment Verification Letter{" "}
          </div>
          <div style={{ color: "#2b2b2bff" }}>
            For current enrollment status
          </div>
        </span>
        <Button
          style={{ minWidth: 150, color: "#006900", borderColor: "#006900" }}
          isOutline
          onClick={() => {
            // setOpen(false);
            fetchVerificationLetter();
          }}
        // status={Status.light}
        >
          <Icon name="download" mr={0.5} />
          Download PDF
        </Button>
      </FlexBox>
        <FlexBox
          style={{
            justifyContent: "space-between",
            paddingTop: 20,
            paddingBottom: 20,
            borderBottom: "1px solid #ddd9d9",
          }}
        >
          <span>
            <div style={{ fontSize: 18, fontWeight: 500, color: "#820000" }}>
              <Icon name="file-s" mr={0.5} />
              Certificate of Student Status{" "}
            </div>
            <div style={{ color: "#2b2b2bff" }}>
              For current student's status
            </div>
          </span>
          <Button
            style={{ minWidth: 150, color: "#006900", borderColor: "#006900" }}
            isOutline
            onClick={() => {
              // setOpen(false);
              fetchCertificateOfStatus();
            }}
          // status={Status.light}
          >
            <Icon name="download" mr={0.5} />
            Download PDF
          </Button>
        </FlexBox>
        <FlexBox style={{ justifyContent: "end", marginTop: 20 }}>
          <Button
            style={{ minWidth: 150 }}
            isOutline
            onClick={() => {
              setOpen(false);
            }}
            status={Status.primary}
          // style={{ padding: "4px 30px" }}
          >
            <Icon name="x-s" mr={0.5} />
            {/* <Icon name="download" mr={0.5} /> */}
            Dismiss
          </Button>
        </FlexBox></>}
    </Modal>
  );
};
